import { DaDataResponse } from '@company/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { StateWithCompany } from '../company-state';
import { getCompanyState } from './feature.selector';

export const getSearchCompanyState: MemoizedSelector<
  StateWithCompany,
  StateUtils.LoaderState<DaDataResponse[]>
> = createSelector(getCompanyState, (state) => state?.search || {});

export const getSearchCompanyLoading: MemoizedSelector<StateWithCompany, boolean> = createSelector(
  getSearchCompanyState,
  (state) => state.loading,
);

export const getSearchCompanyError: MemoizedSelector<StateWithCompany, boolean> = createSelector(
  getSearchCompanyState,
  (state) => state.error,
);

export const getSearchCompanyValue: MemoizedSelector<StateWithCompany, DaDataResponse[]> = createSelector(
  getSearchCompanyState,
  (state) => state.value || [],
);
